import angular from 'angular';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';

VerbatimController.$inject = [
  '$scope',
  'DropdownItemsFactory',
  'TopToolbarFactory',
  '$translate',
  'company',
  'loggedUser',
  '$mdDialog',
  'sites',
  'VerbatimFactory',
  'scenarios',
  'SiteFilterHelperFactory',
  '$timeout',
  'AlertingFactory',
  'MediasFactory',
];
export function VerbatimController(
  $scope,
  DropdownItemsFactory,
  TopToolbarFactory,
  $translate,
  company,
  loggedUser,
  $mdDialog,
  sites,
  VerbatimFactory,
  scenarios,
  SiteFilterHelperFactory,
  $timeout,
  AlertingFactory,
  MediasFactory
) {

  $scope.allScenarios = [];
  $scope.allSites = [];
  $scope.submitQuery = submitQuery;
  $scope.sitesChanged = sitesChanged;
  $scope.scenariosChanged = scenariosChanged;
  $scope.exportXls = exportXls;
  $scope.createReport = createReport;

  function submitQuery() {
    $scope.showSpinner = true;
    var dateRange = {};
    if (($scope.filters.dateRange.from !== null) && ($scope.filters.dateRange.to !== null)) {
      dateRange = {
        'from': VerbatimFactory.formatFromDateForDayRangeQuery($scope.filters.dateRange.from),
        'to': VerbatimFactory.formatToDateForDayRangeQuery($scope.filters.dateRange.to)
      };
    }
    $scope.filteredVerbatims = VerbatimFactory.getVerbatims(
      company.id,
      dateRange,
      $scope.filters
    ).then(
      res => {
        $scope.filteredVerbatims = res.data.verbatims;
        $scope.queryId = res.data.query_id;
      },
      AlertingFactory.httpErrorHandler())
      .finally(() => $scope.showSpinner = false);
  }

  init();

  function init() {
    TopToolbarFactory.setTitleTranslation('verbatim/title', $scope);

    // Filters
    $scope.dateRangeKey = 'company-' + company.id + 'verbatim-dateRange';
    $scope.dateRangeLabel = $translate.instant('verbatim/dateRange');
    $scope.sitesKey = 'company-' + company.id + '-verbatim-sites';
    $scope.sitesLabel = $translate.instant('verbatim/sites');
    $scope.scenariosKey = 'company-' + company.id + '-verbatim-scenarios';
    $scope.scenariosLabel = $translate.instant('verbatim/scenarios');
    $scope.scoresKey = 'company-' + company.id + '-verbatim-scores';
    $scope.scoresLabel = $translate.instant('verbatim/scores');

    // Header labels
    $scope.headers = {
      message_time: $translate.instant('verbatim/result/message_time'),
      site: $translate.instant('verbatim/result/site'),
      scenario: $translate.instant('verbatim/result/scenario'),
      box_text: $translate.instant('verbatim/result/box_text'),
      score: $translate.instant('verbatim/result/score'),
      message_content: $translate.instant('verbatim/result/message_content'),
    };

    $scope.dropdownItems = {};
    $scope.filteredVerbatims = [];
    const filteredSites = SiteFilterHelperFactory.filterSitesThatHaveCapability(sites, loggedUser, CapabilityIdEnum.Statistics);
    $scope.allSitesIds = filteredSites.map(site => site.id);
    $scope.allSites = DropdownItemsFactory.buildSiteItems(filteredSites);
    $scope.allSites.forEach(s => s.type = sites.find(obj => obj.id === s.id).type);
    $scope.allSites.sort((a, b) => (a.sortKey > b.sortKey) ? 1 : ((b.sortKey > a.sortKey) ? -1 : 0));  // Sort them as in the dropdown
    $scope.filteredScenarios = scenarios.filter(scenario => $scope.allSitesIds.includes(scenario.site_id));
    $scope.allScenarios = DropdownItemsFactory.buildScenariosItems($scope.filteredScenarios);
    $scope.filters = {
      dateRange: {
        from: null,
        to: null,
      },
      siteIds: [],
      scenarioIds: [],
      scoreIds: []
    };
    $scope.dropdownItems = {
      sites: $scope.allSites,
      scenarios: $scope.allScenarios,
      scores: DropdownItemsFactory.buildScoresItems($scope.filteredScenarios)
    };

    $timeout(() => {
      // $timeout because we wait select-multiple directives to load selectors from localStorage
      let selectedScenarios = $scope.allScenarios.filter(scenario => $scope.filters.scenarioIds.includes(scenario.id));
      updateScoresFilterAndDropdown(selectedScenarios);
      submitQuery();
    }, 0);
  }

  $scope.redirectToConversation = function (task_id) {
    VerbatimFactory.getTaskView(company.id, task_id);
  }


  function updateScenariosFilterAndDropdown(newScenarios) {
    $scope.dropdownItems.scenarios = DropdownItemsFactory.buildScenariosItems(newScenarios);
    const newScenarioIds = $scope.dropdownItems.scenarios.map(scenario => scenario.id);
    const filteredScenarioIds = $scope.filters.scenarioIds.filter(scenarioId => newScenarioIds.includes(scenarioId));
    $scope.filters.scenarioIds.splice(0, $scope.filters.scenarioIds.length);
    filteredScenarioIds.forEach(id => $scope.filters.scenarioIds.push(id));
  }


  function updateScoresFilterAndDropdown(newScenarios) {
    const newScenarioIds = newScenarios.map(scenario => scenario.id)
    const selectedScenarios = $scope.filteredScenarios.filter(scenario => newScenarioIds.includes(scenario.id));
    $scope.dropdownItems.scores = DropdownItemsFactory.buildScoresItems(selectedScenarios);
    var filteredScoreIds = [];
    $scope.dropdownItems.scores
      .filter(score => $scope.filters.scenarioIds.includes(score.scenarioId))
      .forEach(score => score.subitems.filter(subitem => $scope.filters.scoreIds.includes(subitem.id))
        .forEach(subitem => filteredScoreIds.push(subitem.id)));
    $scope.filters.scoreIds.splice(0, $scope.filters.scoreIds.length);
    filteredScoreIds.forEach(id => $scope.filters.scoreIds.push(id));
  }

  function scenariosChanged() {
    const graphSelectedScenarios = $scope.allScenarios
      .filter(scenario => $scope.filters.scenarioIds.includes(scenario.id));
    updateScoresFilterAndDropdown(graphSelectedScenarios);
    $timeout(() => submitQuery(), 0);
  }

  function sitesChanged() {
    const scenariosForSites = scenarios
      .filter(scenario => $scope.filters.siteIds.includes(scenario.site_id));
    updateScenariosFilterAndDropdown(scenariosForSites);
    updateScoresFilterAndDropdown($scope.dropdownItems.scenarios);
    $timeout(() => submitQuery(), 0);
  }

  function exportXls() {
    VerbatimFactory.createExport(company.id, {
      filters: $scope.filters,
      verbatims: $scope.filteredVerbatims,
      queryId: $scope.queryId
    }).then((response) => {
      const { content, content_type, content_filename } = response.data;
      MediasFactory.downloadBinaryBase64(content, content_type, content_filename);
    }, AlertingFactory.httpErrorHandler());
  }

  function createReport(event) {
    let reportName = 'Verbatim'
    let report = {
      'filters': $scope.filters,
      'name': reportName,
      'send_by': {
        'email': true,
        'ftp': false
      },
      'created_for_users': [loggedUser.id]
    }
    $mdDialog.show({
      controller: [
        '$scope',
        ($scope) => {
          $scope.data = {
            componentName: 'ReportEditionVerbatimDialogComponent',
            dialogTitle: $translate.instant('verbatim-reports/edition/create-title'),
            report: angular.copy(report),
            sites: sites,
            scenarios: scenarios,
            isCreation: true,
          }
          $scope.cancelDialog = $mdDialog.cancel;
          $scope.hideDialog = $mdDialog.hide;
        }
      ],
      template: `<angular-metrics-dialog-container-for-ajs
  [data]="data"
  (hide-dialog)="hideDialog($event)"
  (cancel-dialog)="cancelDialog()"
  ></angular-metrics-dialog-container-for-ajs>`,
      targetEvent: event
    })
  }
}
